<template>
  <div>
    <LoadingContainer v-if="loading" />
    <ErrorDisplay
      v-else-if="error"
      @action-clicked="loadHubs"
    />
    <div
      v-for="(hub, index) in hubs"
      v-else
      :key="hub.entryId"
      class="d-flex flex-column"
    >
      <a
        :href="`http://www.futurevc.co.uk/hubdisplay.cfm?contententryid=${hub.entryId}`"
        target="_blank"
        class="mb-1"
      >
        {{ hub.title }}
      </a>
      <p>{{ hub.summaryText }}</p>
      <p class="font-italic mb-0">
        {{ hub.author }}, {{ dateFormatter(hub.date) }}
      </p>
      <hr
        v-if="index < hubs.length - 1"
        class="my-1 w-100"
      >
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import LoadingContainer from '@/views/components/LoadingContainer.vue'
import ErrorDisplay from '@/views/components/ErrorDisplay.vue'

export default {
  name: 'FvcHubContent',
  components: { ErrorDisplay, LoadingContainer },
  data() {
    return {
      hubs: [],
      loading: false,
      error: false,
    }
  },
  mounted() {
    this.loadHubs()
  },
  methods: {
    loadHubs() {
      this.loading = true
      this.error = false
      /* this.$http.get('/api/hubs')
        .then(response => {
          this.hubs = response.data
        })
        .catch(() => {
          this.error = true
        })
        .finally(() => {
          this.loading = false
        }) */

      this.hubs = [
        {
          entryId: 141,
          title: 'Opportunities in volatility',
          summaryText: 'In the early stages of the COVID pandemic in 2020 there was significant economic turmoil and a stockmarket crash. In the three years...',
          author: 'Tim Mortimer',
          date: '2023-11-23',
        },
        {
          entryId: 140,
          title: 'Identifying trends with StructrPro',
          summaryText: 'StructrPro is a US structured products data service that can be used to analyze both live and matured products from the SRP US database...',
          author: 'Suzi Hampson',
          date: '2023-11-16',
        },
      ]

      // Simulate a delay
      setTimeout(() => {
        this.loading = false
      }, 1000)
    },
    dateFormatter(value) {
      return dayjs(value).isValid() ? dayjs(value).format('DD MMM YYYY') : `${value}`
    },
  },
}
</script>
